const firebaseConfig = {
    apiKey: "AIzaSyBNiwN7jDNZ9450eaiOkJclojB9fjJm7P0", 
    authDomain: "leticia-ensino-medio.firebaseapp.com",
    projectId: "leticia-ensino-medio",
    storageBucket: "leticia-ensino-medio.appspot.com",
    messagingSenderId: "899224858085",
    appId: "1:899224858085:web:91ce67c0747ed73089530c"
};

const firebaseConfigAvisos = {
    apiKey: "AIzaSyBf8RjwbSylZp_BwDNUF1M97b4rShb7oQs",
    authDomain: "avisos-leticia.firebaseapp.com",
    projectId: "avisos-leticia",
    storageBucket: "avisos-leticia.appspot.com",
    messagingSenderId: "1064096034909",
    appId: "1:1064096034909:web:1a85e559fd46ac81a55db4"  
};

const firebaseConfigFormularios = {
    apiKey: "AIzaSyBwhSLGBcQEFJw1BYfIVG_VcVxzdmAwk1M",
    authDomain: "formularios-c458a.firebaseapp.com",
    projectId: "formularios-c458a",
    storageBucket: "formularios-c458a.appspot.com",
    messagingSenderId: "1075545337388",
    appId: "1:1075545337388:web:24185661999e1180c2ab89"  
};

const firebaseConfigCalendario = {
    apiKey: "AIzaSyAtsgFme61j70yqVRvxy876j1-8kb6u7vk",
    authDomain: "calendario-leticia.firebaseapp.com",
    projectId: "calendario-leticia",
    storageBucket: "calendario-leticia.appspot.com",
    messagingSenderId: "62794935391",
    appId: "1:62794935391:web:fc1ab9333b2961fb357fea"
};  
  
export { firebaseConfig, firebaseConfigFormularios, firebaseConfigAvisos, firebaseConfigCalendario };